import AuthGuard from './auth-guard'
import LoggedInGuard from './loggedInGuard'
import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/pages/App/Home'
import Events from '@/pages/App/Events/Events'
import EventsDetails from '@/pages/App/Events/EventsDetails/EventsDetails'
import Attendees from '@/pages/App/Attendees/Attendees'
import Categories from '@/pages/App/Events/Categories/Categories'
import EventCategories from '@/pages/App/Events/Categories/EventCategories'
import EventPreferences from '@/pages/App/Events/Categories/EventPreferences'
import PlaceCategories from '@/pages/App/Events/Categories/PlaceCategories'
import PlacePreferences from '@/pages/App/Events/Categories/PlacePreferences'
import EventPromotors from '@/pages/App/Events/EventPromotors'
import EventDjs from '@/pages/App/Events/EventDjs'
import EventProducts from '@/pages/App/Events/EventProducts'
import EventProductsCategories from '@/pages/App/Events/ProductsCategories'
import EventPlaces from '@/pages/App/Events/EventPlaces'
import EventPurchasesProducts from '@/pages/App/Events/EventsPurchases/PurchasesProducts'
import Auth from '@/pages/Auth/Auth'
import AppNotifications from '@/pages/App/AppNotifications/AppNotifications'
import Apps from '@/pages/App/Apps'
import AppsDetails from '@/pages/App/AppsDetails/AppsDetails'
import Administrators from '@/pages/App/AppsDetails/Administrators'
import Billing from '@/pages/App/Billing/Billing'
import Notifications from '@/pages/App/Notifications'
import Cards from '@/pages/App/Billing/Cards'
import DailyUsage from '@/pages/App/Billing/DailyUsage'
import Emails from '@/pages/App/Emails/Emails.vue'
import EmailSettings from '@/pages/App/EmailSettings/EmailSettings'
import Payments from '@/pages/App/Billing/Payments'
import Campaigns from '@/pages/App/Communications/Campaigns/Campaigns'
import CampaignDetails from '@/pages/App/Communications/CampaignDetails/CampaignDetails'
import ListsPersons from '@/pages/App/Communications/ListsPersons/ListsPersons'
import ListDetails from '@/pages/App/Communications/ListsPersons/ListDetails'
import NewCampaign from '@/pages/App/Communications/NewCampaign/NewCampaign'
import NewSms from '@/pages/App/Communications/NewSms/NewSms'
import AppsRoles from '@/pages/App/Roles/AppsRoles'
import Businesses from '@/pages/App/Businesses/Businesses'
import BusinessDetails from '@/pages/App/Businesses/BusinessDetails'
import NewApp from '@/pages/App/NewApp'
import NewCompany from '@/pages/App/NewCompany'
import Settings from '@/pages/App/Settings'
import Contacts from '@/pages/App/Contacts'
import Desktop from '@/pages/App/Desktop/Desktop'
import SuperDesktop from '@/pages/App/Desktop/SuperDesktop'
import Proximamente from '@/pages/App/Proximamente'
import Formularios from '@/pages/App/Forms/Forms'
import NewEditForm from '@/pages/App/Forms/NewEditForm'
import Triggers from '@/pages/App/Triggers/ListTriggers'
import ListProjects from '@/pages/App/Speech/ListProjects'
import ShowProject from '@/pages/App/Speech/ShowProject'
import KeybeUi from '@/pages/App/KeybeUi/KeybeUi'
import People from '@/pages/App/People/People'
import Journey from '@/pages/App/Journey/Journey'
import JourneyDetails from '@/pages/App/Journey/JourneyDetails'
import SequenceDetails from '@/pages/App/Sequences/SequenceDetails'
import SequenceLeads from '@/pages/App/Sequences/SequenceLeads'
import SequenceStatistics from '@/pages/App/Sequences/SequenceStatistics'
import Sequences from '@/pages/App/Sequences/Sequences'
import SequencesRules from '@/pages/App/Sequences/Rules/Rules'
import Schedules from '@/pages/App/Sequences/Schedules/Schedules'
import UserConfiguration from '@/pages/App/UserConfiguration/UserConfiguration'
// Abad faciolince
import RealEstate from '@/pages/RealEstate/RealEstate.vue'
import RealEstateCreateEditProperty from '@/pages/RealEstate/CreateEditProperty.vue'
import RealEstateOwnersList from '@/pages/RealEstate/OwnersList.vue'
import RealEstatePropertiesList from '@/pages/RealEstate/PropertiesList.vue'
import RealEstateAdvisersList from '@/pages/RealEstate/AdvisersList.vue'
// Proximamente
import Correos from '@/pages/App/Correos/Correos'
import HabeasData from '@/pages/App/HabeasData/HabeasData'
import Historia from '@/pages/App/Historia/Historia'
import MultiPass from '@/pages/App/MultiPass/MultiPass'
import SmartFlows from '@/pages/App/SmartFlows/SmartFlows'
import Soporte from '@/pages/App/Soporte/Soporte'
import PageNotFound from '@/pages/App/PageNotFound'
import Conversations from '@/pages/App/Conversations/Conversations'
import ConversationsMetrics from '@/pages/App/Conversations/Metrics/Metrics'
import ConversationsSettings from '@/pages/App/Conversations/Settings/Settings'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/auth',
      name: 'Auth',
      component: Auth,
      beforeEnter: LoggedInGuard,
      meta: { title: 'Iniciar Sesión' }
    },
    // Below block must be first Home routes because it get conflicts with notFound page if place redirect inside it
    {
      path: '/',
      redirect: '/home'
    },
    {
      path: '/',
      component: Home,
      beforeEnter: AuthGuard,
      children: [
        // aplicaciones
        { path: 'apps', name: 'Aplicaciones', component: Apps, meta: { title: 'Aplicaciones' } },
        { path: 'notifications', name: 'Notificaciones', component: AppNotifications, meta: { title: 'Notificaciones' } },
        { path: 'apps/new', name: 'Nueva Aplicación', component: NewApp, meta: { title: 'Nueva Aplicación' } },
        { path: 'companies/:companyid/apps/:appid', name: 'Detalles', component: AppsDetails, meta: { title: 'Details' } },
        { path: 'companies/:companyid/apps/administrators/:appid', name: 'Administradores', component: Administrators, meta: { title: 'Administradores' } },
        { path: 'user-configuration', name: 'User Configuration', component: UserConfiguration, meta: { title: 'User Configuration' } },
        {
          path: 'billing',
          component: Billing,
          redirect: '/billing/usage',
          children: [
            { path: 'usage', name: 'DailyUsage', component: DailyUsage, meta: { title: 'Billing - Daily Usage' } },
            { path: 'transactions', name: 'Payments', component: Payments, meta: { title: 'Billing - Payment' } },
            { path: 'cards', name: 'Cards', component: Cards, meta: { title: 'Billing - Form of Payment' } }
          ]
        },
        { path: 'companies/:companyid/apps/Journey/:appid', name: 'journey', component: Journey, meta: { title: 'Journey' } },
        { path: 'companies/:companyid/apps/Journey/:appid/:journeyId', name: 'JourneyDetails', component: JourneyDetails, meta: { title: 'Detalles del Journey' } },
        // Sequences
        { path: 'apps/:appid/sequences', name: 'Sequences', component: Sequences, meta: { title: 'Sequences' } },
        { path: 'apps/:appid/sequences/rules', name: 'Sequences rules', component: SequencesRules, meta: { title: 'Sequences rules' } },
        { path: 'apps/:appid/sequences/schedules', name: 'Sequences Schedules', component: Schedules, meta: { title: 'Sequences Schedules' } },
        { path: 'apps/:appid/sequences/:sequenceId/details', name: 'Sequence Details', component: SequenceDetails, meta: { title: 'Sequence Details' } },
        { path: 'apps/:appid/sequences/:sequenceId/leads', name: 'Sequence Leads', component: SequenceLeads, meta: { title: 'Sequence Leads' } },
        { path: 'apps/:appid/sequences/:sequenceId/statistics', name: 'Sequence Statistics', component: SequenceStatistics, meta: { title: 'Sequence Statistics' } },
        /* Events */
        { path: 'apps/:appid/attendees', name: 'Asistentes', component: Attendees, meta: { title: 'Asistentes' } },
        {
          path: 'apps/:appid/categories',
          name: 'Categories',
          component: Categories,
          meta: { title: 'Categories' },
          children: [
            { path: 'eventcategories', name: 'EventCategories', component: EventCategories, meta: { title: 'Event Categories' } },
            { path: 'eventpreferences', name: 'EventPreferences', component: EventPreferences, meta: { title: 'Event Preferences' } },
            { path: 'placecategories', name: 'PlaceCategories', component: PlaceCategories, meta: { title: 'Place Categories' } },
            { path: 'placepreferences', name: 'PlacePreferences', component: PlacePreferences, meta: { title: 'Place Preferences' } }
          ]
        },
        { path: 'apps/:appid/events/promotors', name: 'Promotors', component: EventPromotors, meta: { title: 'Events - Promotores' } },
        { path: 'apps/:appid/events/djs', name: 'Djs', component: EventDjs, meta: { title: 'Events - Djs' } },
        { path: 'apps/:appid/events/products', name: 'Products', component: EventProducts, meta: { title: 'Events - Products' } },
        { path: 'apps/:appid/events/products/categories', name: 'ProductsCategories', component: EventProductsCategories, meta: { title: 'Events - Product Category' } },
        { path: 'apps/:appid/events/places', name: 'Places', component: EventPlaces, meta: { title: 'Events - Places' } },
        { path: 'apps/:appid/events/sales/products', name: 'ProductsSales', component: EventPurchasesProducts, meta: { title: 'Events - Product Sales' } },
        { path: 'apps/:appid/events', name: 'Eventos', component: Events, meta: { title: 'Events' } },
        { path: 'apps/:appid/events/:eventid', name: 'Eventos Detalle', component: EventsDetails, meta: { title: 'Events - Details' } },
        /* end events */
        { path: 'apps/:appid/speech/projects', name: 'Proyectos de Speech To Text', component: ListProjects, meta: { title: 'Proyectos de Speech To Text' } },
        { path: 'apps/:appid/speech/projects/:projectid', name: 'Visualizar Proyecto de Speech To Text', component: ShowProject, meta: { title: 'Visualizar Proyecto de Speech To Text' }, props: true },
        { path: 'apps/:appid/forms', name: 'Formularios', component: Formularios, meta: { title: 'Forms' } },
        { path: 'apps/:appid/forms/new', name: 'Nuevo Formulario', component: NewEditForm, meta: { title: 'New Form' } },
        { path: 'apps/:appid/forms/:formid', name: 'Editar Formulario', component: NewEditForm, meta: { title: 'Edit Form' } },
        { path: 'apps/:appid/triggers', name: 'Disparadores', component: Triggers, meta: { title: 'Disparadores' } },
        { path: 'apps/:appid/notifications', name: 'Notifications', component: Notifications, meta: { title: 'Notifications' } },
        { path: 'apps/:appid/campaigns', name: 'Campaigns', component: Campaigns, meta: { title: 'Campaigns' } },
        { path: 'apps/:appid/campaigns/new', name: 'New Campaign', component: NewCampaign, meta: { title: 'New Campaign' } },
        { path: 'apps/:appid/campaigns/newsms', name: 'New Sms', component: NewSms, meta: { title: 'New Mass SMS' } },
        { path: 'apps/:appid/campaigns/:campaignid', name: 'Detalles de Campana', component: CampaignDetails, meta: { title: 'Campaign Detail' } },
        { path: 'apps/:appid/lists', name: 'Lists Persons', component: ListsPersons, meta: { title: 'Lists' } },
        { path: 'apps/:appid/lists/:listid', name: 'ListDetails', component: ListDetails, meta: { title: 'List Detail' } },
        { path: 'apps/:appid/users', name: 'PeopleDirectory', component: People, meta: { title: 'Leads' } },
        { path: 'apps/:appid/businesses', name: 'Negocios', component: Businesses, meta: { title: 'Companies' } },
        { path: 'apps/:appid/businesses/:businessid', name: 'Negocios Detalle', component: BusinessDetails, meta: { title: 'Companies - Detail' } },
        { path: 'apps/:appid/roles', name: 'Roles', component: AppsRoles, meta: { title: 'Roles' } },
        { path: 'companies/new', name: 'Nuevo Negocio', component: NewCompany, meta: { title: 'New Company' } },
        { path: 'settings', name: 'Configuracion', component: Settings, meta: { title: 'Configuration' } },
        { path: 'contacts', name: 'Contactos', component: Contacts, meta: { title: 'Contactos' } },
        { path: 'home', name: 'Home', component: Desktop, meta: { title: 'Home' } },
        { path: 'superdashboard', name: 'Superuser Home', component: SuperDesktop, meta: { title: 'Reports' } },
        { path: 'keybeui', name: 'Keybe UI', component: KeybeUi, meta: { title: 'Authenticator' } },
        { path: 'proximamente', name: 'Proximamente', component: Proximamente, meta: { title: 'Próximamente' } },
        // PROXIMAMENTE
        { path: 'correos', name: 'Correos', component: Correos, meta: { title: 'Correos' } },
        { path: 'habeasdata', name: 'HabeasData', component: HabeasData, meta: { title: 'Habeas Data' } },
        { path: 'historia', name: 'Historia', component: Historia, meta: { title: 'Historia' } },
        { path: 'multipass', name: 'MultiPass', component: MultiPass, meta: { title: 'MultiPass' } },
        { path: 'smartflows', name: 'SmartFlows', component: SmartFlows, meta: { title: 'SmartFlows' } },
        { path: 'soporte', name: 'Soporte', component: Soporte, meta: { title: 'Soporte' } },
        { path: 'conversations', name: 'Conversaciones', component: Conversations, meta: { title: 'Inbox' } },
        { path: 'conversations/metrics', name: 'ConversationMetrics', component: ConversationsMetrics, meta: { title: 'Inbox Metrics' } },
        { path: 'settings/emails', name: 'EmailSettings', component: EmailSettings, meta: { title: 'Email Configuration' } },
        { path: 'emails', name: 'Emails', component: Emails, meta: { title: 'Emails Outbox' } },
        { path: 'conversations/settings', name: 'ConversationSettings', component: ConversationsSettings, meta: { title: 'Inbox Configuration' } },
        // abad faciolince
        { path: 'realestate', name: 'Real Estate', component: RealEstate, meta: { title: 'RealEstate' } },
        { path: 'realestate/property/new', name: 'Create Property', component: RealEstateCreateEditProperty, meta: { title: 'Create Property' } },
        { path: 'realestate/property/list', name: 'Properties List', component: RealEstatePropertiesList, meta: { title: 'Propiedades' } },
        { path: 'realestate/adviser/list', name: 'Advisers List', component: RealEstateAdvisersList, meta: { title: 'Asesores' } },
        { path: 'realestate/owner/list', name: 'Owners List', component: RealEstateOwnersList, meta: { title: 'Propietarios' } },
        { path: 'realestate/property/:propertyId', name: 'Edit Property', component: RealEstateCreateEditProperty, meta: { title: 'Editar Propiedad' } },
        { path: '*', name: 'NotFoundHome', component: PageNotFound, meta: { title: 'Página no encontada' } }
      ]
    },
    { path: '*', name: 'NotFoundGlobal', component: PageNotFound, meta: { title: 'Página no encontada' } }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title
  next()
})

export default router
